document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu toggle with proper aria-expanded state
  const menuBtn = document.querySelector('[data-mobile-menu]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('mobile-open');
      menuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Product gallery thumbnails
  document.querySelectorAll('[data-main-image]').forEach(main => {
    main.closest('.product-gallery')?.querySelectorAll('[data-image]').forEach(b => {
      b.addEventListener('click', () => {
        const img = main.querySelector('img');
        if (img) {
          img.src = b.dataset.image;
          img.srcset = '';
          if (b.dataset.alt) img.alt = b.dataset.alt;
        }
      });
    });
  });

  // Product variant selection
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const data = form.querySelector('[data-product-variants]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    const selects = [...form.querySelectorAll('[data-option-index]')];
    const idInput = form.querySelector('[name=id]');
    const btn = form.querySelector('[data-add-to-cart]');
    const update = () => {
      const chosen = selects.map(s => s.value);
      const variant = variants.find(v => JSON.stringify(v.options) === JSON.stringify(chosen));
      if (variant) {
        idInput.value = variant.id;
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available
            ? (btn.dataset.labelAvailable || btn.textContent)
            : (btn.dataset.labelSoldOut || btn.textContent);
        }
      }
    };
    selects.forEach(s => s.addEventListener('change', update));
    update();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  // AJAX cart: update quantity / remove line items without a full page reload
  const cartForm = document.querySelector('[data-cart-form]');
  if (!cartForm) return;

  const errorBox = cartForm.querySelector('[data-cart-error]');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');
  let debounceTimer;

  const showError = (message) => {
    if (!errorBox) return;
    errorBox.textContent = message;
    errorBox.hidden = false;
  };
  const clearError = () => {
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = '';
  };

  const updateCartCount = (count) => {
    cartCountEls.forEach(el => { el.textContent = count; });
  };

  const changeLineItem = async (key, quantity, row) => {
    clearError();
    row?.classList.add('is-loading');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error('Request failed');
      const cart = await res.json();
      updateCartCount(cart.item_count);

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      const updatedItem = cart.items.find(i => i.key === key);
      if (quantity === 0 || !updatedItem) {
        row?.remove();
      } else if (row) {
        const priceEl = row.querySelector('[data-line-price]');
        if (priceEl) priceEl.textContent = formatMoney(updatedItem.final_line_price);
      }

      const subtotalEl = cartForm.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    } catch (err) {
      showError((window.SHOPLIO_STRINGS && window.SHOPLIO_STRINGS.cartError) || 'Something went wrong updating your cart. Please try again.');
    } finally {
      row?.classList.remove('is-loading');
    }
  };

  const formatMoney = (cents) => {
    // Falls back to a plain decimal if Shopify's currency formatter isn't available
    try {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  };

  cartForm.querySelectorAll('[data-quantity-input]').forEach(input => {
    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const row = input.closest('[data-cart-item]');
      const key = input.dataset.key;
      const quantity = Math.max(0, parseInt(input.value, 10) || 0);
      debounceTimer = setTimeout(() => changeLineItem(key, quantity, row), 500);
    });
  });

  cartForm.querySelectorAll('[data-remove-item]').forEach(btn => {
    btn.addEventListener('click', () => {
      const row = btn.closest('[data-cart-item]');
      changeLineItem(btn.dataset.key, 0, row);
    });
  });
});
